import { Component, OnInit, Input } from "@angular/core";
import { PagesMenu } from "../../../pages/pages-menu";
import { NbMenuItem } from "@nebular/theme";
import { Router } from "@angular/router";

@Component({
  selector: 'ngx-tab',
  styleUrls: ['./tab.component.scss'],
  templateUrl: './tab.component.html',
})
export class TabComponent implements OnInit {

  public items: NbMenuItem[] = [];
  public active = 0;

  constructor(private pagesMenu: PagesMenu, private router: Router) {
    pagesMenu.getMenu().subscribe(items => {
      this.items = items;
    });
  }

  ngOnInit(): void { }

  goTo(path: string, index: number) {
    this.active = index;
    this.router.navigate([path]);
  }
}
